import axios from 'axios';
import { IBuyerCollection } from 'entities/Buyer/Buyer.models';

const basePath = 'buyer';

export const buyersTransport = {
  get: (): Promise<IBuyerCollection> => axios.get(`${basePath}`),
};
